export function gradeNormalizer(g) {
    if (!g) return "";
    const s = String(g).toUpperCase();
    if (
        s === "K" ||
        s === "KG" ||
        s === "KINDER" ||
        s === "KINDERGARTEN" ||
        s === "0K" ||
        s === "0F" ||
        s === "0H" ||
        s === "00"
    )
        return "K";
    if (s === "1" || s === "01" || s === "FIRST") return "1st";
    if (s === "2" || s === "02" || s === "SECOND") return "2nd";
    if (s === "3" || s === "03" || s === "THIRD") return "3rd";
    if (s === "4" || s === "04" || s === "FOURTH") return "4th";
    if (s === "5" || s === "05" || s === "FIFTH") return "5th";
    if (s === "6" || s === "06" || s === "SIXTH") return "6th";
    if (s === "7" || s === "07" || s === "SEVENTH") return "7th";
    if (s === "8" || s === "08" || s === "EIGHTH") return "8th";
    return g;
}
